import { useIsOnboardingComplete, useOnboardingRouteInfo } from "@sg-protect/shell";
import { type PropsWithChildren } from "react";
import { Navigate } from "react-router";
import { usePaths } from "../../paths.ts";

export function HomeRedirectBoundary({ children }: PropsWithChildren) {
    const paths = usePaths();
    const { isOnZeroStateRoute } = useOnboardingRouteInfo();
    const isOnboardingComplete = useIsOnboardingComplete();

    if (isOnboardingComplete && isOnZeroStateRoute) {
        return <Navigate to={paths.home} replace />;
    }

    return children;
}
